import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import AuthSlice from "../components/authentication/config/AuthSlice";
import HeaderSlice from "../components/config/HeaderSlice";
import eligibilityCheckSlice from "../features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";
import eligibilityCheckListSlice from "../features/eliglibility/eligibility-check-list/config/eligibilityCheckListSlice";
import preauthorizationSlice from "../features/preauthorization/config/preauthorizationSlice";
import practitionerSlice from "../features/practitioner/config/practitionerSlice";
import priceSlice from "../features/price/config/PriceSlice";
import branchSlice from "../features/branch/config/branchSlice";
import SettingsSlice from "../features/field-settings/config/FieldSettingsSlice";
import empolyeeSlice from "../features/empolyee/config/empolyeeSlice";
import roleSlice from "../features/user-permission/config/UserPermissionSlice";
import CliamSlice from "../features/cliams/config/claimSlice";
import ClaimDashboardSlice from "../features/cliams/components/dashboard-claim/config/claimDashboardSlice";
import DashboardSlice from "../features/dashboard/config/dashboardSlice";
import RoleSlice from "../features/system-privillage/config/RoleSlice";
import PaymentSlice from "../features/cliams/components/payment/config/PaymentSlice";
import ClaimPollsSlice from "../features/claim-polls/config/ClaimPollsSlice";
import patientSlice from "../features/patient/config/PatientSlice";
// Combine all reducers
const rootReducer = combineReducers({
  auth: AuthSlice,
  header: HeaderSlice,
  eligibilityCheck: eligibilityCheckSlice,
  eligibilityCheckList: eligibilityCheckListSlice,
  preauthorization: preauthorizationSlice,
  practitioner: practitionerSlice,
  price: priceSlice,
  branch: branchSlice,
  settings: SettingsSlice,
  empolyee: empolyeeSlice,
  role: roleSlice,
  claim: CliamSlice,
  claimDashboard: ClaimDashboardSlice,
  dashboard: DashboardSlice,
  Payment: PaymentSlice,
  roleAdmin: RoleSlice,
  claimPolls: ClaimPollsSlice,
  patient: patientSlice,
});

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "role"], // only auth and role will be persisted
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);
